module.exports = __webpack_public_path__ + "img/2.d9a0d762.jpg";